import keycloakMgr from "../Keycloak";

const FeatureUtils = {

    resolveValues(item, text) {
        if (typeof text === 'undefined') {
            return text;
        }
        let id = item.id;
        if (item && item.properties && typeof item.properties.id !== 'undefined' && item.properties.id !== null) {
            id = item.properties.id;
        }
        if (typeof id === 'undefined' || id === null) {
            id = '';
        }
        text = text.replaceAll("{uuid}", id);
        text = text.replaceAll("{token}", keycloakMgr.get().token);
        text = this.genericResolve(item, text);
        return text;
    },

    // Items endpoint may return a single Feature or a FeatureCollection
    getSingleFeature(data) {
        if (data && data.features) {
            return data.features[0] || null;
        }
        if (data && data.properties) {
            return data;
        }
        return null;
    },

    prepareUrl(item, urlPattern) {
        return this.resolveValues(item, urlPattern);
    },

    genericResolve(object, text) {
        if (typeof object === 'undefined') {
            return text;
        }
        if (typeof text === 'undefined') {
            return text;
        }
        const placeholderRegex = new RegExp("{([^} ]*)}", "g");
        const matches = [...text.matchAll(placeholderRegex)];
        if (matches && matches.length > 0) {
            matches.forEach(m => {
                if (m[0] && m[1]) {
                    const matchString = m[0];
                    const elementDesciptor = m[1];
                    const elements = elementDesciptor.split('.');
                    let levelObject = object;
                    //console.log('Start', matchString, elementDesciptor, levelObject);
                    for (let i = 0; i < elements.length; i++) {
                        const element = elements[i];
                        if (i == elements.length - 1) {
                            // LAST LEVEL
                            if (typeof levelObject[element] === 'string' || typeof levelObject[element] === 'number' || typeof levelObject[element] === 'boolean') {
                                //console.log('Last .. replace string', matchString, levelObject[element]);
                                text = text.replaceAll(matchString, levelObject[element]);
                            } else {
                                const arraySelectMatches = this.genericResolveArrayMatches(element);
                                if (arraySelectMatches) {
                                    const candidate = this.genericResolveArrayValue(levelObject, arraySelectMatches);
                                    if (typeof candidate === 'string' || typeof candidate === 'number' || typeof candidate === 'boolean') {
                                        //console.log('Last .. replace string[]', matchString, candidate);
                                        text = text.replaceAll(matchString, candidate);
                                    }
                                } else {
                                    //console.log('Last .. not a string or array', element, typeof levelObject[element]);
                                }
                            }
                        } else {
                            //console.log('Test', element);
                            const arraySelectMatches = this.genericResolveArrayMatches(element);
                            if (arraySelectMatches) {
                                const candidate = this.genericResolveArrayValue(levelObject, arraySelectMatches);
                                if (candidate === null) {
                                    break;
                                } else {
                                    levelObject = candidate;
                                }
                            } else {
                                // step down in the object
                                if (levelObject[element]) {
                                    //console.log('Child found', element);
                                    levelObject = levelObject[element];
                                } else {
                                    // the child does not exist ... do not proceeed
                                    //console.log('Child not found', element, levelObject);
                                    break;
                                }
                            }
                        }
                    }
                }
            });
        }

        return text;
    },

    genericResolveArrayMatches(element) {
        const arraySelectRegex = new RegExp("([^\\[]+)\\[([^\\]]+)\\]", "g");
        const arraySelectMatches = [...element.matchAll(arraySelectRegex)];
        if (arraySelectMatches && arraySelectMatches.length === 1 && arraySelectMatches[0].length === 3) {
            return arraySelectMatches;
        }
        return null;
    },

    genericResolveArrayValue(levelObject, arraySelectMatches) {
        const arrayElementName = arraySelectMatches[0][1];
        const selector = arraySelectMatches[0][2];
        //console.log('Matches', arrayElementName, selector);
        // step down to an array
        if (levelObject[arrayElementName]) {
            const arrayElement = levelObject[arrayElementName];
            if (arrayElement.constructor === Array) {
                //console.log('Found array child', arrayElementName);
                if (isNaN(selector)) {
                    const compare = selector.split("=");
                    if (compare.length != 2) {
                        //console.log("Compare expression invalid.", compare);
                        return null;
                    } else {
                        const compareVar = compare[0];
                        const compareValue = compare[1];
                        let arrayElementFound = false;
                        for (let j = 0; j < arrayElement.length; j++) {
                            const arrayElementChild = arrayElement[j];
                            if (arrayElementChild[compareVar] == compareValue) {
                                return arrayElementChild;
                            }
                        }
                        return null;
                    }
                } else {
                    if (arrayElement[selector]) {
                        return arrayElement[selector];
                    } else {
                        //console.log('Numeric selector not found', selector, arrayElementName);
                        return null;
                    }
                }
            } else {
                // console.log('Not an array', arrayElementName);
                return null;
            }
        } else {
            // the child does not exist ... do not proceeed
            //console.log('Not a child', arrayElementName);
            return null;
        }
    },

    resolveValue(item, key) {
        return this.prepareUrl(item, '{' + key + '}');
    },

    simpleProperty(item, text) {
        if (typeof text === 'undefined') {
            return text;
        }
        if (item && item.properties) {
            Object.keys(item.properties).forEach(k => {
                text = text.replaceAll('{' + k + '}', item.properties[k]);
            });
        }
        return text;
    },

    assign(item, key, value) {
        const parts = key.split('.');
        for (let i = 0; i < parts.length; i++) {
            const elemName = parts[i];
            if (i === parts.length - 1) {
                const arraySelectMatches = this.genericResolveArrayMatches(elemName);
                if (arraySelectMatches) {
                    const arrayElementName = arraySelectMatches[0][1];
                    const selector = arraySelectMatches[0][2];
                    item[arrayElementName][selector] = value;
                } else {
                    item[elemName] = value;
                }
            } else {
                const arraySelectMatches = this.genericResolveArrayMatches(elemName);
                if (arraySelectMatches) {
                    const arrayElementName = arraySelectMatches[0][1];
                    const selector = arraySelectMatches[0][2];
                    item = item[arrayElementName][selector];
                } else {
                    item = item[elemName];
                }
            }
        }
    },

    unassign(item, key) {
        const parts = key.split('.');
        for (let i = 0; i < parts.length; i++) {
            const elemName = parts[i];
            if (i === parts.length - 1) {
                const arraySelectMatches = this.genericResolveArrayMatches(elemName);
                if (arraySelectMatches) {
                    const arrayElementName = arraySelectMatches[0][1];
                    const selector = arraySelectMatches[0][2];
                    delete item[arrayElementName][selector];
                } else {
                    delete item[elemName];
                }
            } else {
                const arraySelectMatches = this.genericResolveArrayMatches(elemName);
                if (arraySelectMatches) {
                    const arrayElementName = arraySelectMatches[0][1];
                    const selector = arraySelectMatches[0][2];
                    item = item[arrayElementName][selector];
                } else {
                    item = item[elemName];
                }
            }
        }
    },
    getObjectType(feature) {
        return feature.properties.objectType;
    },

    crsToContentCrsHeader(crs) {
        const match = /^EPSG:(\d+)$/i.exec(crs || '');
        if (!match) {
            return null;
        }
        return '<http://www.opengis.net/def/crs/EPSG/0/' + match[1] + '>';
    }
};

/*console.log(
    FeatureUtils.genericResolve(
        { properties: { test: 'bla' } },
        'my name {properties.test}'
    )
);*/

export default FeatureUtils;
